import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_tipo_atividade = _resolveComponent("selecionar-tipo-atividade")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_tipo_frete = _resolveComponent("selecionar-tipo-frete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_checkbox, {
          checked: _ctx.computedFiscal.reidi,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedFiscal.reidi) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("REIDI")
          ]),
          _: 1
        }, 8, ["checked"]),
        _hoisted_3,
        _createVNode(_component_a_checkbox, {
          checked: _ctx.computedFiscal.simplesNacional,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedFiscal.simplesNacional) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Simples Nacional")
          ]),
          _: 1
        }, 8, ["checked"])
      ]),
      (_ctx.props.tipoPessoa !== _ctx.ETipoPessoa.Juridica)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Tipo de atividade",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_tipo_atividade, {
                  codigoSelecionado: _ctx.computedFiscal.tipoAtividade,
                  "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedFiscal.tipoAtividade) = $event))
                }, null, 8, ["codigoSelecionado"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_form_item, {
          label: "ICMS Subst Entrada",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              percentual: true,
              valor: _ctx.computedFiscal.icmsStEntrada,
              "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedFiscal.icmsStEntrada) = $event))
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_form_item, {
          label: "Red.ICMS Entrada",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              percentual: true,
              valor: _ctx.computedFiscal.redIcmsEntrada,
              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedFiscal.redIcmsEntrada) = $event))
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_checkbox, {
          class: "ss-fonte-negrito",
          checked: _ctx.computedFiscal.funrural,
          "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedFiscal.funrural) = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.obterFunruralPadrao()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reter FunRural")
          ]),
          _: 1
        }, 8, ["checked"]),
        _hoisted_8,
        _createVNode(_component_campo_numerico, {
          percentual: true,
          disabled: (!_ctx.computedFiscal.funrural),
          valor: _ctx.computedFiscal.aliquotaFunrural,
          "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedFiscal.aliquotaFunrural) = $event))
        }, null, 8, ["disabled", "valor"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_form_item, {
          label: "ICMS Subst Saída",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              percentual: true,
              valor: _ctx.computedFiscal.icmsStSaida,
              "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedFiscal.icmsStSaida) = $event))
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_form_item, {
          label: "Red.ICMS Saída",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              percentual: true,
              valor: _ctx.computedFiscal.redIcmsSaida,
              "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedFiscal.redIcmsSaida) = $event))
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_a_form_item, {
          label: "Tipo de Frete",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_tipo_frete, {
              valor: _ctx.computedFiscal.tipoFrete,
              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedFiscal.tipoFrete) = $event))
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}